import Icon from 'components/Icon'
import { InviteType } from 'generated/graphql'
import React, { useMemo, useRef, useState } from 'react'
import styled from 'styled-components'
import InfoPopover from './InfoPopover'

const S = {
    InfoIconWrapper: styled.div`
        position: relative;
        height: 100%;
        display: flex;
        align-items: center;
        padding-right: 10px;
        &:after {
            content: '';
            position: absolute;
            width: 100px;
            height: 20px;
            left: -200%;
        }
    `,
}

const MoreOptionsButton = ({ invite, fetchData }: { invite: InviteType, fetchData: () => void }) => {
    const buttonRef = useRef<HTMLDivElement>()
    const [show, setShow] = useState(false)

    const direction = useMemo(() => {
        if (show && buttonRef.current) {
            if (window.innerHeight - buttonRef.current?.getBoundingClientRect().top > 175) {
                return 'down'
            }
        }
        return 'up'
    }, [show])
    return (
        <S.InfoIconWrapper
            ref={buttonRef}
            onClick={() => setShow(!show)}
            onMouseLeave={() => setShow(false)}
        >
            <Icon size={18} icon="drag" />
            {show && (
                <InfoPopover
                    direction={direction}
                    id={invite?.id}
                    fetchData={fetchData}
                    isAccepted={invite?.status === 'accepted'}
                />
            )}
        </S.InfoIconWrapper>
    )
}

export default MoreOptionsButton
